// ==========================================================
// MOBILE BURGER MENU
// ==========================================================
export default function initMobileMenu() {
    const mobileMenu = document.querySelector("[data-mobile-navigation]");

    const mobileMenuOpen = document.querySelector("[data-mobile-menu-open]");

    const mobileMenuClose = document.querySelector("[data-mobile-menu-close]");

    const mobileBreakpoint = window.matchMedia("(max-width: 1023px)");

    if (mobileMenu && mobileMenuOpen && mobileMenuClose) {
        const menuItems = Array.from(mobileMenu.querySelectorAll(".menu-item-has-children"));

        // ======================================================
        // FERMETURE DES SOUS-MENUS
        // ======================================================

        const closeSubmenus = () => {
            menuItems.forEach((item) => {
                item.classList.remove("is-open");

                const link = item.querySelector(":scope > a");

                if (link) {
                    link.setAttribute("aria-expanded", "false");
                }
            });
        };

        // ======================================================
        // OUVERTURE DU MENU
        // ======================================================

        const openMobileMenu = () => {
            if (!mobileBreakpoint.matches) {
                return;
            }

            mobileMenu.classList.add("is-open");

            mobileMenu.classList.remove("invisible");

            mobileMenu.setAttribute("aria-hidden", "false");

            mobileMenuOpen.setAttribute("aria-expanded", "true");

            document.body.classList.add("mobile-menu-open");

            /**
             * On place le focus sur le bouton
             * de fermeture une fois le menu ouvert.
             */

            window.requestAnimationFrame(() => {
                mobileMenuClose.focus();
            });
        };

        // ======================================================
        // FERMETURE DU MENU
        // ======================================================

        const closeMobileMenu = (restoreFocus = true) => {
            mobileMenu.classList.remove("is-open");

            mobileMenu.classList.add("invisible");

            mobileMenu.setAttribute("aria-hidden", "true");

            mobileMenuOpen.setAttribute("aria-expanded", "false");

            document.body.classList.remove("mobile-menu-open");

            /**
             * On referme également tous
             * les accordéons.
             */

            closeSubmenus();

            /**
             * Retour du focus sur le burger.
             */

            if (restoreFocus && mobileBreakpoint.matches) {
                mobileMenuOpen.focus();
            }
        };

        // ======================================================
        // SOUS-MENUS / ACCORDÉONS
        // ======================================================

        menuItems.forEach((item) => {
            const link = item.querySelector(":scope > a");

            const subMenu = item.querySelector(":scope > .sub-menu");

            if (!link || !subMenu) {
                return;
            }

            /**
             * État initial.
             */

            link.setAttribute("aria-expanded", "false");

            // ==================================================
            // CLIC SUR UN ITEM AVEC ENFANTS
            // ==================================================

            link.addEventListener("click", (event) => {
                /**
                 * On ne modifie jamais
                 * le comportement desktop.
                 */

                if (!mobileBreakpoint.matches) {
                    return;
                }

                event.preventDefault();

                const isOpen = item.classList.contains("is-open");

                const parentMenu = item.parentElement;

                // ==========================================
                // FERME LES AUTRES ITEMS DU MÊME NIVEAU
                // ==========================================

                if (parentMenu) {
                    Array.from(parentMenu.children).forEach((sibling) => {
                        if (sibling === item || !sibling.classList.contains("menu-item-has-children")) {
                            return;
                        }

                        sibling.classList.remove("is-open");

                        const siblingLink = sibling.querySelector(":scope > a");

                        if (siblingLink) {
                            siblingLink.setAttribute("aria-expanded", "false");
                        }
                    });
                }

                // ==========================================
                // OUVRE / FERME L'ITEM
                // ==========================================

                item.classList.toggle("is-open", !isOpen);

                link.setAttribute("aria-expanded", String(!isOpen));
            });
        });

        // ======================================================
        // LIENS NORMAUX
        // ======================================================

        mobileMenu.querySelectorAll("a").forEach((link) => {
            const parentItem = link.parentElement;

            /**
             * On vérifie si ce lien contrôle
             * directement un sous-menu.
             */

            const controlsSubmenu = parentItem?.classList.contains("menu-item-has-children") && parentItem.querySelector(":scope > a") === link;

            /**
             * Les liens qui contrôlent un accordéon
             * sont déjà gérés plus haut.
             */

            if (controlsSubmenu) {
                return;
            }

            /**
             * Un lien normal ferme le menu.
             */

            link.addEventListener("click", () => {
                closeMobileMenu(false);
            });
        });

        // ======================================================
        // BURGER
        // ======================================================

        mobileMenuOpen.addEventListener("click", openMobileMenu);

        // ======================================================
        // CROIX
        // ======================================================

        mobileMenuClose.addEventListener("click", () => {
            closeMobileMenu();
        });

        // ======================================================
        // ESCAPE
        // ======================================================

        document.addEventListener("keydown", (event) => {
            if (event.key !== "Escape") {
                return;
            }

            if (mobileMenu.getAttribute("aria-hidden") === "true") {
                return;
            }

            closeMobileMenu();
        });

        // ======================================================
        // RETOUR DESKTOP
        // ======================================================

        mobileBreakpoint.addEventListener("change", (event) => {
            /**
             * Si on repasse à >= 1024px,
             * on remet complètement le menu
             * mobile à zéro.
             */

            if (!event.matches) {
                closeMobileMenu(false);
            }
        });
    }
}